import React from 'react';
import { Link } from 'react-router-dom';
import './Products.css';
import boppLaminatedBagImage from '../assets/bopp-laminated-bag.jpg';
import ppWovenSacksImage from '../assets/pp-woven-sacks.jpg';
import laminatedWovenSacksImage from '../assets/laminated-woven-sacks.jpg';
import fibcBagsImage from '../assets/fibc-bags-1.png';
import ppRollsImage from '../assets/pp-rolls.jpg';

const Products = () => {

  const products = [
    {
      id: 1,
      slug: 'bopp-laminated-bags',
      sectionId: 'bopp-bags',
      name: 'BOPP Laminated Bags',
      description: 'High-definition reverse printed film laminated onto woven fabric. Ideal for FMCG, Premium Rice, and Animal Feed, requiring superior shelf appeal.',
      features: ['High-Definition Printing', 'Superior Shelf Appeal', 'FMCG Grade', 'Premium Quality'],
      image: boppLaminatedBagImage
    },
    {
      id: 2,
      slug: 'pp-woven-bags',
      sectionId: 'pp-woven-bags',
      name: 'PP Woven Sacks/Bags',
      description: 'The toughest and most cost-effective packaging. Used for bulk materials in Agriculture, Construction, Chemicals, and Consumer Goods.',
      features: ['Toughest Packaging', 'Cost-Effective', 'Bulk Materials', 'Industrial Grade'],
      image: ppWovenSacksImage
    },
    {
      id: 3,
      slug: 'laminated-woven-bags',
      sectionId: 'laminated-bags',
      name: 'Laminated Woven Bags',
      description: 'Extrusion coated to provide a moisture barrier. Essential for Cement, Grain, and Fertilizers to protect contents from the environment.',
      features: ['Moisture Barrier', 'Environmental Protection', 'Extrusion Coated', 'Weather Resistant'],
      image: laminatedWovenSacksImage
    },
    {
      id: 4,
      slug: 'fibc',
      sectionId: 'fibc',
      name: 'FIBC',
      description: 'Flexible Intermediate Bulk Containers for various industries',
      features: ['Clean room/Food safe', 'Make a Bag', 'Builder', 'Baffle Bag', 'Electrostatic', 'UN', 'Ventilated', '1 & 2 Loops', 'FIBC Liners'],
      image: fibcBagsImage
    },
    {
      id: 5,
      slug: 'pp-rolls',
      sectionId: 'pp-rolls',
      name: 'PP Rolls',
      description: 'High-strength polypropylene woven rolls used as base material for converting, laminating, printing, and industrial packaging applications.',
      features: ['High Tensile Strength', 'Uniform Weave', 'Custom Width Options', 'Conversion Ready'],
      image: ppRollsImage
    }
  ];


  return (
    <section id="products" className="products section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Packaging Excellence: Our Core Products</h2>
          <p className="section-subtitle">
            High-Quality PP Woven and BOPP Packaging Solutions for Every Industry
          </p>
        </div>


        <div className="products-grid">
          {products.map(product => (
            <div key={product.id} className="product-card" id={product.sectionId}>
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-content">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                <div className="product-features">
                  {product.features.map((feature, index) => (
                    <span key={index} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <Link to={`/products/${product.slug}`} className="btn btn-primary">Know More</Link>
              </div>
            </div>
          ))}
        </div>

        <div className="quality-note">
          <div className="quality-content">
            <i className="fas fa-check-circle"></i>
            <p>
              Our Company has its own well equipped in-house quality control department 
              carry out "In Process Quality Control" (IPQC) in each and every phase of 
              production, from raw material to final product.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
